import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttendanceCode } from '../../../../classroom360/attendance/models/attendance-code.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';

@Component({
  selector: 'app-mass-update-student-attendance',
  templateUrl: './mass-update-student-attendance.component.html'
})
export class MassUpdateStudentAttendanceComponent implements OnInit {
  attendanceCodes: AttendanceCode[] = [];
  selectedAttendanceCodeId = '';
  errors: ErrorList[] = [];
  @ViewChild('periodCode', { read: ElementRef }) periodCodeRef: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<MassUpdateStudentAttendanceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.attendanceCodes = this.data.attendanceCodes;
  }

  closeClick() {
    this.dialogRef.close();
  }

  applyClick() {
    this.errors = [];
    if (this.attendanceCodes.find(x => x.Id == this.selectedAttendanceCodeId).PromptForPartialMinutes) {
      this.errors.push({
        fieldName: 'Attendance Code',
        fieldRef: this.periodCodeRef,
        errorMsg: 'Can not mark L,E, All Day.'
      });
    }

    if (this.errors.length == 0) {
      this.dialogRef.close(this.selectedAttendanceCodeId);
    }
  }

}
